import React, { useEffect, useState } from "react";
import { appsDataTypes } from "./workflowDetails";
import { workflowTypes } from "../../../Types/Workflow-Types";
import { Step } from "react-joyride";
import WorkflowGuideModal from "./WorkflowGuideModal";
import TourGuide from "./TourGuide";
import rawSteps from "../TourGuideSteps.json";
import { Placement } from "react-joyride";

interface WorkflowGuideProps {
  show: boolean;
  handleClose: () => void;
  workflowData: workflowTypes;
}
const WorkflowGuide = ({
  show,
  handleClose,
  workflowData,
}: WorkflowGuideProps) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedWorkflowDetails, setSelectedWorkflowDetails] = useState<
    appsDataTypes[]
  >([]);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  useEffect(() => {
    const combinedData = workflowData?.apps.map((app) => {
      const result = workflowData?.workflowRuns?.[0].workflowAppResults?.find(
        (res) => res.workflowAppId == app.id
      );
      return {
        appId: app.appId,
        appType: app.appType,
        suiteType: app.suiteType,
        inputType: app.inputType,
        outputType: app.outputType,
        appOrder: app.appOrder,
        input: result?.input || "",
        output: result?.output || "",
        isFinished: !!result,
      };
    });

    setSelectedWorkflowDetails(combinedData);
  }, [workflowData]);

  // Map rawSteps to ensure placement is typed correctly
  const steps: Step[] = rawSteps.map((step: any) => ({
    ...step,
    placement: step.placement as Placement,
  }));

  return (
    <>
      <WorkflowGuideModal
        show={show}
        isMobile={isMobile}
        steps={steps}
        title={workflowData?.name}
        selectedWorkflowDetails={selectedWorkflowDetails}
        handleClose={handleClose}
        currentStep={currentStep}
      />
      <TourGuide
        steps={steps}
        setCurrentStep={setCurrentStep}
        handleClose={handleClose}
      />
    </>
  );
};

export default WorkflowGuide;
